import React from "react";
import Header from "../Header/Header";

function QuizHome() {
  return (
    <>
      <Header></Header>
      <h1>Welcome to Quiz Home Page</h1>
    </>
  );
}

export default QuizHome;
